import React, { useRef, useState } from "react";
import { Form, Offcanvas } from "react-bootstrap";
import {
  faAngleRight,
  faEye,
  faEyeSlash,
  faPlug,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Organisation_Offcan.css";
import Blue_Btn from "../../../../common/common_btn/blue_btn/Blue_Btn";
import Common_Back_Btn from "../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { useForm } from "react-hook-form";
import Gray_Btn from "../../../../common/common_btn/gray_btn/Gray_Btn";
import PasswordChecklist from "react-password-checklist";

const Organisation_Offcan = ({ show, handleClose }) => {
  const fileInputRef = useRef(null);
  const [profileImg, setProfileImg] = useState(
    "/assets/images/header/profile/user1.png"
  );

  const [isEdit, setIsEdit] = useState();

  const handlePlusClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Only images
    if (!file.type.startsWith("image/")) return;

    // Create preview URL
    const previewUrl = URL.createObjectURL(file);
    setProfileImg(previewUrl);
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    setError,
  } = useForm();

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEye);
  const [iconTwo, setIconTwo] = useState(faEye);

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  return (
    <Offcanvas
      className="Organisation_Offcan common_offcanvas Profile_Offcanvas Account_Setting_Offcan"
      show={show}
      placement="end"
      onHide={handleClose}
      scroll={false}
      backdrop={true}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn backText="Organization Details" />
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="body_div">
          <>
            <Form className="add_form all_tabs_holder">
              <div className="white_box">
                <p className="form_section_title">Basic Information:</p>

                <Form.Group className="form_group" controlId="formBasicName">
                  <Form.Label>Organization Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Organization Name"
                  />

                  {errors?.credit_price && (
                    <Form.Text className="text-danger">
                      {errors?.credit_price?.message}
                    </Form.Text>
                  )}
                </Form.Group>

                <Form.Group className="form_group" controlId="formBasicName">
                  <Form.Label>Registered Address / Lab Address</Form.Label>
                  <Form.Control
                    as={"textarea"}
                    type="text"
                    placeholder="Type here..."
                  />

                  {errors?.credit_price && (
                    <Form.Text className="text-danger">
                      {errors?.credit_price?.message}
                    </Form.Text>
                  )}
                </Form.Group>

                <div className="row">
                  <div className="col-lg-6">
                    <Form.Group
                      className="form_group"
                      controlId="formBasicName"
                    >
                      <Form.Label>Contact No.</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Contact No."
                      />

                      {errors?.credit_price && (
                        <Form.Text className="text-danger">
                          {errors?.credit_price?.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-lg-6">
                    <Form.Group
                      className="form_group"
                      controlId="formBasicName"
                    >
                      <Form.Label>Official Email ID</Form.Label>
                      <Form.Control type="text" placeholder="Enter Email ID" />

                      {errors?.credit_price && (
                        <Form.Text className="text-danger">
                          {errors?.credit_price?.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>
                </div>
              </div>

              <div className="gray_input_box">
                <p className="form_section_title">
                  Legal & Compliance Information:
                </p>

                <div className="row">
                  <div className="col-lg-6">
                    <Form.Group
                      className="form_group"
                      controlId="formBasicName"
                    >
                      <Form.Label>GST Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter GST Number"
                      />

                      {errors?.credit_price && (
                        <Form.Text className="text-danger">
                          {errors?.credit_price?.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-lg-6">
                    <Form.Group
                      className="form_group"
                      controlId="formBasicName"
                    >
                      <Form.Label>PAN Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter PAN Number"
                      />

                      {errors?.credit_price && (
                        <Form.Text className="text-danger">
                          {errors?.credit_price?.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>
                </div>

                <Form.Group className="form_group" controlId="formBasicName">
                  <Form.Label>CIN Number (If Company Is Registered)</Form.Label>
                  <Form.Control type="text" placeholder="Enter CIN" />

                  {errors?.credit_price && (
                    <Form.Text className="text-danger">
                      {errors?.credit_price?.message}
                    </Form.Text>
                  )}
                </Form.Group>

                <Form.Group className="form_group" controlId="formBasicName">
                  <Form.Label>NABL Accreditation Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter NABL Accreditation Number"
                  />

                  {errors?.credit_price && (
                    <Form.Text className="text-danger">
                      {errors?.credit_price?.message}
                    </Form.Text>
                  )}
                </Form.Group>

                <div className="row">
                  <Form.Group className="form_group" controlId="formBasicName">
                    <Form.Label>Validity Dates Of Accreditations</Form.Label>
                  </Form.Group>

                  <div className="col-lg-6">
                    <Form.Group
                      className="form_group"
                      controlId="formBasicName"
                    >
                      <Form.Label>Valid From:</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter GST Number"
                      />

                      {errors?.credit_price && (
                        <Form.Text className="text-danger">
                          {errors?.credit_price?.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>
                  <div className="col-lg-6">
                    <Form.Group
                      className="form_group"
                      controlId="formBasicName"
                    >
                      <Form.Label>Valid To:</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter PAN Number"
                      />

                      {errors?.credit_price && (
                        <Form.Text className="text-danger">
                          {errors?.credit_price?.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>
                </div>
              </div>

              <div className="white_box pb-3">
                <p className="form_section_title">Lab Identification Details</p>

                <Form.Group className="form_group" controlId="formBasicName">
                  <Form.Label>Lab Code / Branch Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Lab Code / Branch Code"
                  />

                  {errors?.credit_price && (
                    <Form.Text className="text-danger">
                      {errors?.credit_price?.message}
                    </Form.Text>
                  )}
                </Form.Group>

                <Form.Group className="form_group" controlId="formBasicName">
                  <Form.Label>
                    Type Of Laboratory (Coal Testing / Chemical / Mechanical
                    Etc.)
                  </Form.Label>
                  <div className="types_holder">
                    <div className="type_div">
                      <p className="type_text">Coal Testing</p>
                    </div>
                    <div className="type_div">
                      <p className="type_text">Chemical Testing</p>
                    </div>
                  </div>
                </Form.Group>
              </div>
            </Form>
          </>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Organisation_Offcan;
